export default __webpack_public_path__ + "static/media/PDF_Default_Icon.978163b3.svg";